export class CreateDimensionStateError extends Error {

}